import { PhoenixModule } from 'phoenix/phoenix';
import { filtersModule } from './filters';
import { componentsModule } from './components';
import { datastoreModule } from './dataStores';
import { servicesModule } from './services';

/**
 * @ngdoc overview
 * @name sharebase
 * @module sharebase
 * @description
 *
 * # sharebase (module)
 * The sharebase module contains components and services available to any
 * application using the sharebase platform
 *
 * Examples of services provided by this module are:
 * - shares
 * - comments
 * - notifications
 */
export const ShareBaseModule = angular
	.module('sharebase', [
		PhoenixModule.name,
		servicesModule.name,
		datastoreModule.name,
		componentsModule.name,
		filtersModule.name,
		'util',
		'gettext'
	])
	.constant('SB_CHAR_LIMIT', 200);


// WEBPACK FOOTER //
// ./src/sharebase/sharebase.ts